var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('TableView',{attrs:{"title":_vm.$t('components.PScores.title'),"emptyText":_vm.$t('components.PScores.empty'),"uri":"/pscores","toName":"pscoresId","limit":"5"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('PScoreRow',{attrs:{"score":item}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }